import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import isObjectLike from 'lodash/isObjectLike';
import isString from 'lodash/isString';
import { SpecTypes, isArraySpec, isObjectSpec, isStringSpec, } from '../../core';
import { isFloat } from '../validators/helpers';
import { divide } from './bigIntMath';
export const isNotEmptyValue = (value, spec) => {
    var _a;
    if (isNil(value)) {
        return false;
    }
    if (isString(value)) {
        if (!value) {
            return false;
        }
        if (isStringSpec(spec) && ((_a = spec.viewSpec.hideValues) === null || _a === void 0 ? void 0 : _a.includes(value))) {
            return false;
        }
    }
    if (isObject(value) && isObjectSpec(spec)) {
        const keys = Object.keys(value);
        // the only case when an empty object is considered a non-empty value is when it is a stub for oneof
        if (!keys.filter((key) => { var _a; return isNotEmptyValue(value[key], (_a = spec.properties) === null || _a === void 0 ? void 0 : _a[key]); }).length &&
            spec.viewSpec.type !== 'oneof') {
            return false;
        }
    }
    if (isArray(value) &&
        isArraySpec(spec) &&
        !value.filter((item) => isNotEmptyValue(item, spec.items)).length) {
        return false;
    }
    return true;
};
export const prepareSpec = (spec, parseJsonDefaultValue) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (isObjectLike(spec)) {
        const result = cloneDeep(spec);
        if (isString(result.type)) {
            result.type = result.type.toLowerCase();
        }
        if (!isNil(result.defaultValue)) {
            let _defaultValue = result.defaultValue;
            if (parseJsonDefaultValue) {
                try {
                    _defaultValue = JSON.parse(result.defaultValue);
                }
                catch (_j) {
                    _defaultValue = undefined;
                }
            }
            if (typeof _defaultValue === result.type ||
                (isArray(_defaultValue) && result.type === SpecTypes.Array)) {
                result.defaultValue = _defaultValue;
            }
            else {
                result.defaultValue = undefined;
            }
        }
        if (isString((_a = result.viewSpec) === null || _a === void 0 ? void 0 : _a.type)) {
            result.viewSpec.type = result.viewSpec.type.toLowerCase();
        }
        if (isString((_b = result.viewSpec) === null || _b === void 0 ? void 0 : _b.layout)) {
            result.viewSpec.layout = result.viewSpec.layout.toLowerCase();
        }
        if (isString((_c = result.viewSpec) === null || _c === void 0 ? void 0 : _c.addButtonPosition)) {
            result.viewSpec.addButtonPosition = result.viewSpec.addButtonPosition.toLowerCase();
        }
        if (isString((_d = result.viewSpec) === null || _d === void 0 ? void 0 : _d.themeLabel)) {
            result.viewSpec.textContentParams = Object.assign(Object.assign({}, result.viewSpec.textContentParams), { themeLabel: result.viewSpec.themeLabel.toLowerCase() });
        }
        if (isString((_f = (_e = result.viewSpec) === null || _e === void 0 ? void 0 : _e.oneOfParams) === null || _f === void 0 ? void 0 : _f.toggler)) {
            result.viewSpec.oneOfParams.toggler = result.viewSpec.oneOfParams.toggler.toLowerCase();
        }
        if (isString((_h = (_g = result.viewSpec) === null || _g === void 0 ? void 0 : _g.textContentParams) === null || _h === void 0 ? void 0 : _h.themeLabel)) {
            result.viewSpec.textContentParams.themeLabel =
                result.viewSpec.textContentParams.themeLabel.toLowerCase();
        }
        if (isString(result.validator)) {
            result.validator = result.validator.toLowerCase();
        }
        if (result.maxLength === '0' &&
            result.minLength === '0') {
            result.maxLength = undefined;
            result.minLength = undefined;
        }
        else {
            if (!isNil(result.maxLength) && isFloat(`${result.maxLength}`)) {
                result.maxLength = BigInt(result.maxLength);
            }
            if (!isNil(result.minLength) && isFloat(`${result.minLength}`)) {
                result.minLength = BigInt(result.minLength);
            }
        }
        if (result.items) {
            result.items = prepareSpec(result.items, parseJsonDefaultValue);
        }
        if (result.maximum === 0 && result.minimum === 0) {
            result.maximum = undefined;
            result.minimum = undefined;
        }
        else {
            if (!isNil(result.maximum) && isFloat(`${result.maximum}`)) {
                result.maximum = Number(result.maximum);
            }
            if (!isNil(result.minimum) && isFloat(`${result.minimum}`)) {
                result.minimum = Number(result.minimum);
            }
        }
        if (isString(result.format)) {
            result.format = result.format.toLowerCase();
        }
        if (isObjectLike(result.properties)) {
            Object.keys(result.properties).forEach((key) => {
                result.properties[key] = prepareSpec(result.properties[key], parseJsonDefaultValue);
            });
        }
        return result;
    }
    return spec;
};
export const isCorrectSizeParams = (spec) => {
    const { sizeParams } = spec.viewSpec;
    if (!sizeParams ||
        !isString(sizeParams.defaultType) ||
        !isObject(sizeParams.scale) ||
        !sizeParams.scale[sizeParams.defaultType] ||
        Object.values(sizeParams.scale).some(({ factor }) => !divide(factor, factor))) {
        return false;
    }
    return true;
};
